/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */
import { RequestManager, Client, HTTPTransport } from '@open-rpc/client-js';
const httpOptions = {
    headers: {},
};
const client = new Client(new RequestManager([new HTTPTransport('/', httpOptions)]));
class MathClient {
    async getAssist(solution, problem) {
        const params = {
            solution,
            problemGraph: JSON.stringify(problem),
            parameters: {
                gradingMethod: 'CorrectIncorrect',
                usePartialGrading: false,
            },
            req_timeout: 5000,
        };
        return await client.request({ method: 'assist', params });
    }
    async getAssistMessages() {
        return await client.request({ method: 'get_messages', params: { req_timeout: 5000 } });
    }
}
export const mathClient = new MathClient();
